import { ReactElement } from 'react';

import { Box, Flex, SystemStyleObject } from '@vimeo/bokeh';
import { ChartGrowthAlt } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { Optional } from '@vimeo/core/types/generic';
import { TInteractionHistoryConnection } from '@vimeo/live-core/types/interaction_tools';

import { createInteractionDomName } from '../../../libs/shared/utils/dom/identifying';
import { EmptyStatePlaceholder } from '../../shared/tools/shared';

interface IPollEmptyStateProps extends IBaseDomElementProps {
  buttonLabel: string;
  description: string;
  height?: string;
  width?: string;
  maxWidth?: string;
  padding?: string;
  control?: Optional<ReactElement> | boolean;
  history?: Optional<Array<TInteractionHistoryConnection>>;
  sx?: SystemStyleObject;
  onCreateClick(): void;
}

export function PollEmptyState({
  id = createInteractionDomName('poll-empty-state'),
  className = createInteractionDomName('poll-empty-state'),
  control,
  buttonLabel,
  description,
  height,
  width,
  maxWidth,
  padding,
  sx,
  onCreateClick,
}: IPollEmptyStateProps) {
  return (
    <Box
      id={id}
      className={className}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      height={height}
      width={width}
      padding={padding}
      sx={sx}
    >
      <Flex direction={'column'} maxWidth={maxWidth}>
        <EmptyStatePlaceholder
          id={createInteractionDomName(id, 'empty-placeholder')}
          className={createInteractionDomName(id, 'empty-placeholder')}
          flexGrow={0}
          height={'auto'}
          control={control}
          buttonLabel={buttonLabel}
          description={description}
          icon={<ChartGrowthAlt boxSize={'lg'} />}
          onButtonClick={onCreateClick}
        />
      </Flex>
    </Box>
  );
}
